import Vue from 'vue';
import Radio from './radio.vue';

Vue.component(Radio.name, Radio);
